<template>
  <div class="">
    <NavBar v-show="isNavBarShow" />
    <div class="min-h-screen pt-60">
      <slot></slot>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import { useWindowScroll } from '@vueuse/core'

const route = useRoute()
const { y } = useWindowScroll()

const isNavBarShow = computed(() => {
  if (route.path === '/' && y.value < 700) return false
  return true
})
</script>

<style lang="scss" scoped>
// .v-enter-active,
// .v-leave-active {
//   transition: opacity 0.25s ease;
// }

// .v-enter-from,
// .v-leave-to {
//   opacity: 0;
// }
</style>
